import { Modal } from '@iziwork/design-system';
import { FC } from 'react';

import { useTranslation } from '~/hooks';

export const ApplyUnknownHeader: FC = () => {
  const { t } = useTranslation();
  return <Modal.Header title={t('apply.title_you_are_new')} subtitle={t('apply.subtitle_resume_to_apply')} />;
};
